module.exports = __webpack_public_path__ + "img/biggou.b7982654.png";